const states = new Set([
  'succeeded',
  'failed',
  'pending',
  'canceled',
  'not_dispatched',
  'unknown',
]);

// Ordinal is the whole-chain position, never the per-kind retry number.
// Reconstruct numbers only from a complete classified prefix; old gaps stay unknown.
export const numberRetryAttemptsV111 = (attempts, incomplete = false) => {
  let known = !incomplete;
  let dispatched = 0;
  let initialObserved = false;
  const used = { same_source_retry: 0, fallback_retry: 0 };
  return attempts.map((attempt) => {
    if (attempt.kind === 'request' && attempt.ordinal === 1) {
      initialObserved = true;
    }
    if (!attempt.kind) {
      if (attempt.dispatched) known = false;
    } else if (
      attempt.ordinal !== dispatched + 1 ||
      (dispatched === 0 && !initialObserved) ||
      (dispatched > 0 && attempt.kind === 'request')
    ) {
      known = false;
    }
    const retry = Object.prototype.hasOwnProperty.call(used, attempt.kind);
    const number =
      attempt.retry_number_v111 ||
      (known && retry && attempt.dispatched ? used[attempt.kind] + 1 : null);
    if (attempt.dispatched) {
      dispatched++;
      if (retry) used[attempt.kind]++;
    }
    return { ...attempt, retry_number_v111: number };
  });
};

export const retryRequestStateV111 = (audit) => {
  if (states.has(audit.request_state_v111)) return audit.request_state_v111;
  if (audit.status !== 'recorded' || audit.truncated) return 'unknown';
  if (audit.outcome?.endsWith('_success')) return 'succeeded';
  if (audit.outcome?.endsWith('_failure')) return 'failed';
  return states.has(audit.outcome) ? audit.outcome : 'unknown';
};

export const latestRetryAttemptV111 = (audit) => {
  if (audit.latest_attempt_v111) return audit.latest_attempt_v111;
  const attempts = numberRetryAttemptsV111(
    audit.attempts?.length
      ? audit.attempts
      : audit.attempt_sequence_v1022 || [],
    audit.truncated
  );
  if (audit.truncated) return null;
  return attempts[attempts.length - 1] || null;
};

export const retryAttemptResultV111 = (attempt) => {
  if (attempt.outcome === `${attempt.kind}_success`) return 'attempt_success';
  if (attempt.outcome === `${attempt.kind}_failure`) return 'attempt_failure';
  return ['pending', 'canceled', 'not_dispatched'].includes(attempt.outcome)
    ? attempt.outcome
    : 'unknown';
};
